import { ActionReducer } from '@ngrx/store';
import { clearStore } from '../actions/app.actions';

export function clearStateMetaReducer(reducer: ActionReducer<any>): ActionReducer<any> {
    return function(state, action) {
        if (action.type === clearStore.type) {
            state = undefined; // esto forzará a cada reducer a retornar su estado inicial
        }
        return reducer(state, action);
    };
}